

import {
  CHANGE_REPORT_URL
} from "./report-action-types";


const initialState = {
  reportUrl: ""
};


export default (state = initialState, action) => {
  const { reportUrl } = action;

  switch(action.type) {



    case CHANGE_REPORT_URL:
      return {
        ...state,
        reportUrl
      };



    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/modules/report/report-reducer.js